import { Admin } from '@springtree/eva-services-admin';
import buildServiceState from '../../builders/build-service-state.js';
const adminModuleListState = buildServiceState({
    allowEmptyRequest: true,
    key: 'adminModuleList',
    service: Admin.AdminGetAllModules,
    requireLoggedIn: false,
    requireCustomer: false,
    requireEmployee: false,
});
export default adminModuleListState;
//# sourceMappingURL=admin-module-list-state.js.map